/**
 * openSupportEmail — « Une question ? » : écrire au support, du même geste partout côté élève.
 *
 * Sur le web, l'adresse de la page devient le `mailto:` : le navigateur passe la main au logiciel de
 * courriel sans ouvrir d'onglet. `Linking.openURL` y ouvrirait un onglet `_blank`, laissé vide
 * derrière le courriel. C'est le geste des écrans legacy de l'élève (`BecomePremiumCard.js:133-138`,
 * `SettingsConfigurationScreen.js:216-222`). Ailleurs, l'app de courriel par `Linking`.
 *
 * Le geste vaut pour toute adresse qu'une autre app ouvre (`mailto:`, `tel:`, `sms:`) :
 * `openAppLink`, que lisent aussi les liens touchés d'un message et « Email » de « Tous mes lives ».
 * Une adresse web garde `Linking`, qui l'ouvre dans un onglet sur le web.
 *
 * Un appareil sans app de courriel n'ouvre rien : un cas attendu, qui laisse un fil d'Ariane Bugsnag
 * (le Bugsnag de chaque plateforme, `engine/shared/bugsnagClient{,.web}`) pour qu'une plainte « le
 * bouton ne fait rien » se lise.
 *
 * Pur : aucun état, aucun hook — un écran peut l'appeler directement.
 */
import { Linking, Platform } from "react-native"

import { bugsnagClient } from "../../../../engine/shared/bugsnagClient"

export const SUPPORT_MAILTO_URL = "mailto:support@masteur.com"

/** Une adresse web (`http:`, `https:`) : un onglet sur le web. Le reste passe la main à une autre app. */
const WEB_ADDRESS = /^https?:/i

/** Ouvre une adresse ; sur le web, celle d'une autre app passe par la page, sans onglet vide. */
export function openAppLink(href: string): Promise<void> {
    if (Platform.OS === "web" && typeof window !== "undefined" && !WEB_ADDRESS.test(href)) {
        window.location.href = href
        return Promise.resolve()
    }
    return Linking.openURL(href)
}

export function openSupportEmail(): void {
    openAppLink(SUPPORT_MAILTO_URL).catch((cause: unknown) => {
        bugsnagClient.leaveBreadcrumb("support: courriel non ouvert", {
            platform: Platform.OS,
            cause: cause instanceof Error ? cause.message : String(cause),
        })
    })
}
